/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
              //Hover effects for icons on eval page
              $(".eval-iconset").hover(function() {
                  if (!$(this).hasClass("eval-icon-open")) {
                      var rollOvr = $(this).attr('data-rollover');
                      var iconDef = $(this).attr('data-default');
                      if (rollOvr == $(this).attr('src')) {
                          $(this).attr('src', iconDef);
                      } else {
                          $(this).attr('src', rollOvr);
                      }
                  }
              }, function() {
                  if (!$(this).hasClass("eval-icon-open")) {
                      var iconDef = $(this).attr('data-default');
                      $(this).attr('src', iconDef);
                  }
              });

          $(document).on('click touchstart','.chev-down', function () {
              $(".chev-down").toggleClass("glyphicon-chevron-down glyphicon-chevron-right");
              $(".big-table").slideToggle( 400 );
          });
          $(document).on('click touchstart','.chev-down2', function () {
              $(".chev-down2").toggleClass("glyphicon-chevron-down glyphicon-chevron-right");
              $(".big-table2").slideToggle( 400 );
          });
          $(document).on('click touchstart', '.open-eval', function() {
              $(".open-eval-icon").toggleClass("glyphicon-chevron-down glyphicon-chevron-right");
              $(".work-eval").slideToggle( 400 );
          });
          $(document).on('click touchstart','.open-deliv', function () {
              $(".open-deliv-icon").toggleClass("glyphicon-chevron-down glyphicon-chevron-right");
              $(".work-deliv").slideToggle( 400 );
          });

        $(document).on('click touchstart', '.eval-icon', function () {

         var rollover = $(this).attr("data-rollover");
          $(this).attr('src', rollover);

          var allIcons = $('.eval-iconset');
          allIcons.addClass('eval-icon');
          allIcons.removeClass('eval-icon-open');

          allIcons.each(function(i, obj) {
            $(this).attr('src', $(this).attr("data-default"));
          });


          var rollover = $(this).attr("data-rollover");
          $(this).attr('src', rollover);

          $(this).addClass('eval-icon-open');
          $(this).removeClass('eval-icon');

        });


        $(document).on('click', '.tri-down', function () {
          $('#table-bot').addClass('animated slideInDown');
          //$('#table-bot').addClass('animated slideOutUp');
        });

          $( document ).ready(function() {
              //console.log(window.location.href);
              var urlArr = (window.location.href).split('#');
              if (urlArr[1]) {
                  var theurl = urlArr[0]+'/'+ urlArr[1] + '?ajax=1';
                  //console.log(theurl);
                  $.get( theurl, function( data ) {
                      $( "#ajax-content" ).html( data );
                      var pageW = $(document).width();
                      if (pageW < 1440) {
                          if (pageW < 440) {
                              $('html, body').animate({ scrollTop: '+1300' }, 1000);
                          } else {
                              $('html, body').animate({ scrollTop: '+500' }, 1000);
                          }
                      } else {
                          $('html, body').animate({ scrollTop: '+525' }, 1000);
                      }
                  });
              }
              //console.log(urlArr);
          });

          $(document).on('click touchstart', '.magic-load', function () {

              // prevent
              event.preventDefault();
              $('.tab-pane').removeClass('active');
              var href = $(this).attr('href');
              if(!(href == 0)){
                  function cap(href) {
                      var res = href.split("/");
                      var name = res[4];
                      var res2 = name.split("-");
                      var res3 = [];
                      for (i = 0; i < res2.length; i++) {
                          res3.push((res2[i].charAt(0).toUpperCase() + res2[i].slice(1)));
                      }
                      var evalname2 = res3.join(' ');
                      if (evalname2 == "Immigration"){
                          evalname2 = 'U.S. Immigration';
                      }
                      return evalname2;
                  }

                  var evalname = $(this).find(":selected").text();
                  if (evalname == ''){
                      evalname = (cap(href) + " ");
                  }
                  console.log( evalname );
                  document.title = evalname + "| ";
                  $('.replace-me-eval').text(' - ' +evalname);
                  var theurl = String(href);

                  var thehost = window.location.origin;

                  var thehost = thehost.replace('http:', '');

                  var thehost = thehost.replace('https:', '');

                  var thenavurl = theurl.replace(thehost, '');

                  console.log( thenavurl );
                  var arr = thenavurl.split('/');

                  document.location.hash = arr[2];

                  console.log(String(href));


                  var theurl = String(href) + '?ajax=1';
                  var pageW = $(document).width();
                  $.get( theurl, function( data ) {
                      $( "#ajax-content" ).html( data );

                      if (pageW < 1440) {
                          if (pageW < 440) {
                              $('html, body').animate({ scrollTop: '+1050' }, 1000);
                          } else {
                              $('html, body').animate({ scrollTop: '+450' }, 1000);
                          }
                      } else {
                          $('html, body').animate({ scrollTop: '+425' }, 1000);
                      }
                  });

              }

          });

        $( ".dropdown-eval" ).change(function() {

          if(!($(this).val() == 0)){

              //
              // console.log( window.location.origin );
              //

              var evalname = $(this).find(":selected").text();
              // console.log( evalname );
              document.title = evalname + "| ";
              $('.replace-me-eval').text(' - ' +evalname);

              var theurl = String($(this).val());

              var thehost = window.location.origin;

              var thehost = thehost.replace('http:', '');

              var thehost = thehost.replace('https:', '');

              var thenavurl = theurl.replace(thehost, '');

              console.log( thenavurl );
              var arr = thenavurl.split('/');

              document.location.hash = arr[2];

              //window.history.replaceState("object or string", "Title", thenavurl);


              var theurl = String($(this).val()) + '?ajax=1';

            $.get( theurl, function( data ) {
              $( "#ajax-content" ).html( data );
              // alert( "Load was performed." );
              // window.history.pushState("eval", "Title", $(this).val());
                var pageW = $(document).width();
                if (pageW < 1440) {
                    if (pageW < 440) {
                        //$('html, body').animate({ scrollTop: '+500' }, 1000);
                        $("#ajax-content").animate({ scrollTop: '-200' }, 1000);
                    } else {
                        $('html, body').animate({ scrollTop: '+550' }, 1000);
                    }
                } else {
                    $('html, body').animate({ scrollTop: '+525' }, 1000);
                }

            });

            // window.location.href = '?ajax=1&p=' + $(this).val();
          }
          // console.log(  $(this).val() );

        });




        $('#slickvideo').slick({
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: true,
          responsive: [
            {
              breakpoint: 1124,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true,
                arrows: false
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
        });



      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
